export default __webpack_public_path__ + "static/media/Recogido-por-la-transportadora.5a7d2a1a.svg";